import { createSlice } from '@reduxjs/toolkit';

const adminSlice = createSlice({
    name: 'admin',
    initialState: {
        selectedUser: null,
        userList: [],
    },
    reducers: {
        setAdminUserList: (state, action) => {
            state.userList = action.payload;
        },
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload.userId;
        },
        clearAdminData: () => null,
    },
});

export const { setAdminUserList, clearAdminData, setSelectedUser } = adminSlice.actions;
export default adminSlice.reducer;